import React, { Component } from 'react';
import { Grid, AppBar, Card, Typography, Table, TableRow, TableCell, TableHead, TableBody, Toolbar } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles/index';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as Actions from '../store/actions';

const styles = theme => ({
    root: {}
});

class NewUsersWidget extends Component {

    constructor(props) {
        super(props);
        this.props.getNewUsers()
    }

    render() {
        return (
            <React.Fragment>
                <AppBar position="static">
                    <Toolbar>
                        <Typography variant="h6" color="inherit">
                            New Users
                        </Typography>
                    </Toolbar>

                </AppBar>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell>Full Name</TableCell>
                            <TableCell>Email</TableCell>
                            <TableCell>Companies</TableCell>
                            <TableCell>Roles</TableCell>
                            <TableCell>Creation Date</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {this.props.newUserList.map(user => {
                            return (
                                <TableRow key={user.auth_id}>
                                    <TableCell>{user.FullName}</TableCell>
                                    <TableCell>{user.Email}</TableCell>
                                    <TableCell>{user.Companies.map(c => c.CompanyName + " ")}</TableCell>
                                    <TableCell>{user.Roles.map(r => r.RoleName + " ")}</TableCell>
                                    <TableCell>{user.CreationDate}</TableCell>
                                </TableRow>
                            )
                        })}
                    </TableBody>
                </Table>
            </React.Fragment>

        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getNewUsers: Actions.getNewUsers
    }, dispatch);
}

function mapStateToProps({ auth, dashboardApp }) {
    return {
        auth: auth,
        newUserList: dashboardApp.widgets.newUserList
    }
}


export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(NewUsersWidget)));


// WEBPACK FOOTER //
// src/main/content/dashboard/widgets/NewUsersWidget.js